import { PdfExportDomain } from '@mode/shared/contract-common';
import { PdfExportResource } from './pdf-export-response.types';

export function toPdfExport(resource: PdfExportResource): PdfExportDomain.PdfExport {
  const state = resource.state as PdfExportDomain.PdfExportState;
  switch (state) {
    case PdfExportDomain.PdfExportState.Completed:
      return {
        state: PdfExportDomain.PdfExportState.Completed,
        filename: resource.filename,
        downloadLink: resource._links.download?.href,
      };
    case PdfExportDomain.PdfExportState.Failed:
      return {
        state: PdfExportDomain.PdfExportState.Failed,
        filename: resource.filename,
        error: new Error('API Failure'),
      };
    default:
      return {
        state,
        filename: resource.filename,
      };
  }
}
